import { useCallback } from "react"

const DOMAIN = "Customers"
const SUBDOMAIN = "Legacy"

export enum TrackingPage {
  Optin = "Optin",
}

export enum TrackingAction {
  OptinSuccess = "OptinSuccess",
}

export const useTracking = (page: TrackingPage) => {
  const track = useCallback(
    (action: TrackingAction, payload: Record<string, any> = {}) => {
      window.izPushEvent(DOMAIN, SUBDOMAIN, page, action, payload)
    },
    [page],
  )

  return {
    track,
  }
}
